import type { SessionState } from '@/state/types.ts';
// Generate Insight 1 text (after first silence)
export function generateInsight1(state: SessionState): string {
  const B = state.baselineMood;
  const S = state.silenceCheckins;
  
  if (S.length < 1) {
    return 'Let\'s continue and see how you feel.';
  }

  const delta = S[0].mood - B;
  const direction = delta > 0 ? 'more relaxed' : delta < 0 ? 'more stressed' : 'about the same';
  const absDelta = Math.abs(delta);

  if (absDelta < 0.25) {
    return 'Compared to the baseline you feel about the same.';
  }

  return `Compared to the baseline you feel ${direction}.`;
}

// Generate Insight 2 text (after second silence)
export function generateInsight2(state: SessionState): string {
  const S = state.silenceCheckins;
  if (S.length < 2) {
    return 'Let\'s keep tracking how this changes.';
  }

  const delta = S[1].mood - S[0].mood;
  const direction = delta > 0 ? 'more relaxed' : delta < 0 ? 'more stressed' : 'about the same';
  const absDelta = Math.abs(delta);

  if (absDelta < 0.25) {
    return 'Compared to the first insight you feel about the same.';
  }

  return `Compared to the first insight you feel ${direction}.`;
}

// Get the appropriate insight based on insight index
export function getInsightText(state: SessionState, insightIndex: number): string {
  if (insightIndex === 1) {
    return generateInsight1(state);
  }
  
  if (insightIndex === 2) {
    return generateInsight2(state);
  }
  
  return 'Continue to explore how music affects you.';
}
